import PropTypes from 'prop-types'
import './PageTitle.css'

export default function PageTitle({ title }) {
  return (
    <div className="page-title-container">
      <div className="page-title-wrapper">
        <div className="page-title-content">
          <h1 className="page-title">{title}</h1>
        </div>
      </div>
    </div>
  )
}

PageTitle.propTypes = {
  title: PropTypes.string.isRequired
}
